export default __webpack_public_path__ + "static/VectorDesktop-ec029d387b47e42dfc48a6d346250e84.png";